// extracted by mini-css-extract-plugin
module.exports = {"container":"EditGovernmentFormContent_container__Gxb9P","iframe":"EditGovernmentFormContent_iframe__aoUxL","padding":"EditGovernmentFormContent_padding__L1bUw"};